import {
  ServerResponseType,
  GetCommissionsTemplateResponseType,
  RateType,
  CommissionDetailsType,
  SegmentType,
} from './types';

const findRate = (
  type: RateType,
  segment: SegmentType,
  template: ServerResponseType[0]
) =>
  (
    template.rates.find(r => r.type === type && r.segment === segment)?.rate ??
    0
  ).toLocaleString('en', { style: 'percent' });

const buildTemplateData = (
  type: RateType,
  template: ServerResponseType[0]
): CommissionDetailsType => {
  return {
    currentlyInsuredHomeOwner: findRate(
      type,
      'currentlyInsuredHomeOwner',
      template
    ),
    currentlyInsuredRenter: findRate(type, 'currentlyInsuredRenter', template),
    currentlyUninsured: findRate(type, 'currentlyUninsured', template),
  };
};

export const transformCommissionsTemplateResponse = (
  response: ServerResponseType
): GetCommissionsTemplateResponseType => {
  const options = response
    .map(t => t.name.toUpperCase())
    .sort()
    .reduce((acc, opt) => {
      return {
        ...acc,
        [opt]: `Template ${opt}`,
      };
    }, {});

  const templates = response.reduce((acc, template) => {
    return {
      ...acc,
      [template.name]: {
        newBusiness: {
          ...buildTemplateData('newBusiness', template),
        },
        renewal: {
          ...buildTemplateData('renewal', template),
        },
      },
    };
  }, {});

  return {
    options,
    templates,
  };
};
